import { ValueFormatterParams } from 'ag-grid-community';
import applicationConstants from '../../../../Core/Utility/ApplicationConstants';
import { DemeterInsurancePositionModel } from '../../../../Generated/Raven-Demeter';
import { TableDatum, TableHeader } from '../../../Components/Tables/Table/TableDefinitions';
import formattingService from '../../../Services/Formatting/FormattingService';
import languageService from '../../../Services/Language/LanguageService';
import { translationKeys } from '../../../Services/Language/TranslationDefinitions';

export const positionsColumnDefinitions: TableHeader<DemeterInsurancePositionModel>[] = [
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.companyName),
        field: 'companyName',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.policyNumber),
        field: 'policyNumber',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.state),
        field: 'state',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.commodity),
        field: 'commodity',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.triggerPrice),
        field: 'triggerPrice',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.premiumPrice),
        field: 'premiumPrice',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.netCoveredVolume),
        field: 'netCoveredVolume',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.endorsementDate),
        field: 'endorsementDate',
        dataFormat: 'date',
    },
    {
        headerValueGetter: () => languageService.translate(translationKeys.positions.fields.coveragePeriod),
        field: 'coveragePeriodDate',
        cellRenderer: (parameters: TableDatum<DemeterInsurancePositionModel>) =>
            formattingService.toLongDayMonthYear(parameters.coveragePeriodDate) || parameters.coverageQuarter!,
    },
];

export const positionsColumnOptions = {
    resizable: true,
    autoHeaderHeight: true,
    wrapHeaderText: true,
    flex: 1,
    rowDragManaged: true,
    animateRows: true,
    wrapText: true,
    enableCellChangeFlash: true,
    headerClass: 'ag-header-cell-flex-start',
    comparator: () => 0,
    valueFormatter: (parameters: ValueFormatterParams) => {
        if (!parameters.value) {
            return applicationConstants.TablePlaceholderZeroOrEmpty;
        }

        return parameters.value;
    },
    sortable: true,
};
